import { useDocumentStore } from "../store/document";

export function setMoving(val: boolean) {
  const documentStore = useDocumentStore();
  documentStore.moving = val;
}
